
































import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable,} from "@/resources/components/BaseOverview.vue";
import User from "@/app/models/User";
import {TranslateResult} from 'vue-i18n';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    $refs!: {
        overview: BaseOverview;
    };

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await User.index(loadable.page)).data
        );
    }

    reset() {
        this.$refs.overview.reset();
    }
}
